module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("\n        Planos\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n        Contrato " + _vm._s(_vm.contractId) + "\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Extrato\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t30"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('form', {
    staticClass: "form form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doFilter(true)
      }
    }
  }, [_c('div', {
    staticClass: "inline filter-period"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "period"
  }, [_vm._v("Período:")]), _vm._v(" "), _c('dropdown', {
    staticClass: "dropdown-lastdays",
    attrs: {
      "options": _vm.lastDaysOptions
    },
    model: {
      value: (_vm.lastDays),
      callback: function($$v) {
        _vm.lastDays = $$v
      },
      expression: "lastDays"
    }
  }), _vm._v(" \n                ")], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lastDays == 'custom'),
      expression: "lastDays == 'custom'"
    }],
    staticClass: "inline filter-range"
  }, [_c('div', {
    staticClass: "inline margin-side"
  }, [_c('div', {
    staticClass: "form-group form-inline",
    class: {
      'has-error': _vm.errors.has('Data-inicial')
    }
  }, [_c('label', [_vm._v("De:")]), _vm._v(" "), _c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control picker statement",
    attrs: {
      "name": "Data-inicial",
      "format": "dd/MM/yyyy",
      "language": "pt-br",
      "data-vv-rules": "required"
    },
    model: {
      value: (_vm.customStart),
      callback: function($$v) {
        _vm.customStart = $$v
      },
      expression: "customStart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("Data-inicial")) + "\n                  ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "inline margin-side"
  }, [_c('div', {
    staticClass: "form-group form-inline",
    class: {
      'has-error': _vm.errors.has('Data-final')
    }
  }, [_c('label', [_vm._v("Até:")]), _vm._v(" "), _c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control picker statement",
    attrs: {
      "name": "Data-final",
      "format": "dd/MM/yyyy",
      "language": "pt-br",
      "data-vv-as": "data inicial"
    },
    model: {
      value: (_vm.customEnd),
      callback: function($$v) {
        _vm.customEnd = $$v
      },
      expression: "customEnd"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("Data-final")) + "\n                  ")])], 1)])]), _vm._v(" "), (_vm.plan != 7) ? _c('div', {
    staticClass: "inline filter-plate"
  }, [_c('div', {
    staticClass: "inline margin-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showPlate),
      expression: "showPlate"
    }],
    staticClass: "check-terms",
    attrs: {
      "id": "filter-plate",
      "type": "checkbox",
      "name": "filter-plate",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.showPlate) ? _vm._i(_vm.showPlate, "") > -1 : (_vm.showPlate)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showPlate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showPlate = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showPlate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showPlate = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-terms",
    attrs: {
      "for": "filter-plate"
    }
  }, [_vm._v("Filtrar por Placa")])]), _vm._v(" "), (_vm.showPlate) ? _c('div', {
    staticClass: "form-group form-plate",
    class: {
      'has-error': _vm.errors.has('plate')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plate),
      expression: "plate"
    }, {
      name: "mask-plate",
      rawName: "v-mask-plate"
    }],
    staticClass: "form-control plate-field upper",
    attrs: {
      "type": "search",
      "name": "plate",
      "placeholder": "Digite a Placa"
    },
    domProps: {
      "value": (_vm.plate)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doFilter(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first("plate")))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inline filter-button text-center"
  }, [_c('button', {
    staticClass: "btn btn-purple btn-sm btn-filter",
    attrs: {
      "type": "button",
      "name": "btnFind"
    },
    on: {
      "click": function($event) {
        return _vm.doFilter(true)
      }
    }
  }, [_vm._v("\n                Filtrar\n              ")])]), _vm._v(" "), (_vm.plan != 7) ? _c('div', {
    staticClass: "inline filter-button text-center"
  }, [_c('a', {
    staticClass: "btn btn-download-excel bold btn-filter",
    class: {
      'btn-consolidated-disabled': !_vm.canDownloadConsolidated || _vm.downloadingConsolidated
    },
    attrs: {
      "target": "_blank",
      "aria-disabled": !_vm.canDownloadConsolidated || _vm.downloadingConsolidated,
      "type": "button",
      "name": "button",
      "download": ""
    },
    on: {
      "click": function($event) {
        return _vm.doFilterDownload()
      }
    }
  }, [_c('i', {
    staticClass: "icon-xls align-icon-left-white"
  }), _vm._v("\n                Extrato Consolidado\n              ")])]) : _vm._e()])])]), _vm._v(" "), (_vm.searchState == 'NOTFOUND') ? _c('div', {
    staticClass: "alert alert-warning margin-t10"
  }, [_vm._v("\n        Nenhum dado encontrado no período.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.searchState == 'ERROSEARCH') ? _c('div', {
    staticClass: "alert alert-danger margin-t10"
  }, [_c('ol', [_c('li', [_vm._v(_vm._s(_vm.messageError))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [(_vm.searchState == 'FOUND') ? [(_vm.data) ? _c('div', {
    staticClass: "row margin-t20 resumo-table",
    attrs: {
      "id": "resumeTable"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table no-footer",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.data.summary), function(s, index) {
    return _c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("barWrap")(s.historic)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(s.quantity))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('span', {
      class: _vm.numberClass(s)
    }, [_vm._v(_vm._s(s.type == "D" ? "R$ - " : "R$ ") + _vm._s(_vm._f("centsNoSymbol")(s.value)))])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.checkPlan()) ? _c('div', {
    staticClass: "statement-header-info"
  }, [_c('p', {
    staticClass: "inline description-box"
  }), _vm._v(" "), _c('p', {
    staticClass: "inline date-box"
  }), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('div', {
    staticClass: "content-box result"
  }, [_c('ul', {
    staticClass: "result-list"
  }, _vm._l((_vm.data.statements.itens), function(t, index) {
    return _c('li', {
      key: t.id
    }, [_c('div', {
      staticClass: "margin-t10"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.listTransactionRefund),
        expression: "listTransactionRefund"
      }],
      staticClass: "check-item",
      attrs: {
        "type": "checkbox",
        "name": "listTransactionRefund",
        "id": t.id
      },
      domProps: {
        "value": t.id,
        "checked": Array.isArray(_vm.listTransactionRefund) ? _vm._i(_vm.listTransactionRefund, t.id) > -1 : (_vm.listTransactionRefund)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.listTransactionRefund,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = t.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.listTransactionRefund = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.listTransactionRefund = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.listTransactionRefund = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "label-item",
      class: {
        'passage-labelb':
        t.idHistoric == 1101 || t.idHistoric == 2101,
      },
      attrs: {
        "for": t.id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "timeline",
      class: {
        'margin-b10': t.idHistoric == 1332
      }
    }, [_c('div', {
      staticClass: "inline text-center timeline-icon"
    }, [_c('div', {
      staticClass: "icon-bg",
      class: {
        'margin-5':
        t.idHistoric == 1101 ||
          t.idHistoric == 2101 ||
          t.idHistoric == 1327 ||
          t.idHistoric == 2327,
      }
    }, [_c('i', {
      class: _vm.getClassIcon(t)
    })])]), _vm._v(" "), (
      t.idHistoric == 1101 ||
      t.idHistoric == 2101 ||
      t.idHistoric == 1327 ||
      t.idHistoric == 2327
    ) ? _c('div', {
      staticClass: "inline description-box"
    }, [_c('div', {
      staticClass: "inline line-height-1"
    }, [_c('b', {
      staticClass: "upper block"
    }, [_vm._v(_vm._s(t.description))]), _vm._v(" "), _c('div', {
      staticClass: "plate-box"
    }, [_c('p', {
      staticClass: "cell-plate"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.plate = t.plate;
          _vm.doFilter(true);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("plate")(t.plate)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "inline"
    }, [_c('div', {
      staticClass: "expand-item"
    }, [_c('i', {
      staticClass: "icon-road"
    }), _vm._v(" "), _c('p', {
      staticClass: "inline no-margin"
    }, [_vm._v("\n                              " + _vm._s(t.description) + "\n                            ")])]), _vm._v(" "), _c('div', {
      staticClass: "expand-item"
    }, [_c('i', {
      staticClass: "icon-axis"
    }), _vm._v(" "), _c('p', {
      staticClass: "inline no-margin"
    }, [_vm._v("\n                              CAT" + _vm._s(t.classifiedClass < 10 ?
      "0" +
      t.classifiedClass +
      " - " +
      t.categoryAxesName :
      t.classifiedClass +
      " - " +
      t.categoryAxesName) + "\n                            ")])])])])]) : (t.idHistoric == 1313 || t.idHistoric == 1314) ? _c('div', {
      staticClass: "inline middle description-box"
    }, [_c('b', {
      staticClass: "upper middle"
    }, [_vm._v(_vm._s(t.description))])]) : (t.idHistoric == 1332) ? _c('div', {
      staticClass: "inline middle description-box line-height-1"
    }, [_c('b', {
      staticClass: "upper middle block"
    }, [_vm._v(_vm._s(t.description))]), _vm._v(" "), _c('div', {
      staticClass: "plate-box"
    }, [_c('p', {
      staticClass: "cell-plate"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.plate = t.plate;
          _vm.doFilter(true);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("plate")(t.plate)))])])])])]) : _c('div', {
      staticClass: "inline middle description-box"
    }, [_c('b', {
      staticClass: "upper middle"
    }, [_vm._v(_vm._s(_vm._f("barWrap")(t.description)))])]), _vm._v(" "), (
      t.idHistoric == 1101 ||
      t.idHistoric == 2101 ||
      t.idHistoric == 1327 ||
      t.idHistoric == 2327
    ) ? _c('div', {
      staticClass: "inline date-box pass-box"
    }, [_c('div', {
      staticClass: "inline pass"
    }, [_c('b', {
      staticClass: "middle block"
    }, [_vm._v("Passagem em")]), _vm._v(" "), _c('div', {
      staticClass: "inline line-height-2"
    }, [_c('p', {
      staticClass: "no-margin"
    }, [_vm._v("\n                            " + _vm._s(_vm._f("date")(t.occurrenceDate)) + "\n                          ")]), _vm._v(" "), _c('p', {
      staticClass: "no-margin"
    }, [_vm._v("\n                            " + _vm._s(_vm._f("time")(t.occurrenceDate)) + "\n                          ")])]), _vm._v(" "), _c('i', {
      staticClass: "icon-info",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "top",
        "title": "Data de ocorrência"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "inline"
    }, [_c('b', {
      staticClass: "middle block"
    }, [_vm._v("Recebida em")]), _vm._v(" "), _c('div', {
      staticClass: "inline line-height-2"
    }, [_c('p', {
      staticClass: "no-margin"
    }, [_vm._v("\n                            " + _vm._s(_vm._f("date")(t.processingDate)) + "\n                          ")]), _vm._v(" "), _c('p', {
      staticClass: "no-margin"
    }, [_vm._v("\n                            " + _vm._s(_vm._f("time")(t.processingDate)) + "\n                          ")])]), _vm._v(" "), _c('i', {
      staticClass: "icon-info",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "top",
        "title": "Data de processamento"
      }
    })])]) : _c('div', {
      staticClass: "inline date-box"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "inline line-height-2"
    }, [_c('p', {
      staticClass: "no-margin"
    }, [_vm._v(_vm._s(_vm._f("date")(t.processingDate)))]), _vm._v(" "), _c('p', {
      staticClass: "no-margin"
    }, [_vm._v(_vm._s(_vm._f("time")(t.processingDate)))])]), _vm._v(" "), _c('i', {
      staticClass: "icon-info",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "top",
        "title": "Data de processamento"
      }
    })]), _vm._v(" "), (_vm.checkPlan()) ? _c('div', {
      staticClass: "value-box"
    }, [_vm._m(4, true), _vm._v(" "), _c('div', {}, [_c('p', {
      staticClass: "inline text-right pass-box",
      class: _vm.getValueClass(t)
    }, [_vm._v("\n                          R$\n                          "), _c('b', [_vm._v(_vm._s(_vm._f("centsNoSymbol")(t.value)))])]), _vm._v(" "), _c('p', {
      staticClass: "inline text-right pass-box balance",
      class: t.saldoDepois >= 0 ? 'blue' : 'red'
    }, [_vm._v("\n                          R$\n                          "), _c('b', [_vm._v(_vm._s(_vm._f("centsNoSymbol")(t.saldoDepois)))])])])]) : _c('div', {
      staticClass: "value-box velse"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {}, [_c('p', {
      staticClass: "inline text-right pass-box",
      class: _vm.getValueClass(t)
    }, [_vm._v("\n                          R$\n                          "), _c('b', [_vm._v(_vm._s(_vm._f("centsNoSymbol")(t.value)))])])])])])]), _vm._v(" "), _c('hr', {
      staticClass: "separator"
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row row-fix result-bar"
  }, [_c('div', {
    staticClass: "text-left col-md-4"
  }, [_c('p', [_vm._v("\n                Itens selecionados:\n                "), _c('span', [_vm._v(_vm._s(_vm.listTransactionRefund.length))])])]), _vm._v(" "), _c('div', {
    staticClass: "export-content col-md-8"
  }, [_c('button', {
    staticClass: "btn btn-default btn-sm margin-10",
    class: {
      'btn-purple': _vm.listTransactionRefund.length > 0,
        disabled: _vm.listTransactionRefund.length == 0,
    },
    attrs: {
      "type": "button",
      "name": "btnFind"
    },
    on: {
      "click": function($event) {
        return _vm.downloadExtractFile('partial')
      }
    }
  }, [_vm._v("\n                Exportar selecionados\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm margin-10",
    attrs: {
      "type": "button",
      "name": "btnFind"
    },
    on: {
      "click": function($event) {
        return _vm.downloadExtractFile('full')
      }
    }
  }, [_vm._v("\n                Exportar tudo\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('pagination', {
    attrs: {
      "model": _vm.page
    },
    on: {
      "page-change": _vm.setCurrentPage
    }
  })], 1)]), _vm._v(" "), (_vm.data && _vm.data.transactions && _vm.data.transactions.transaction) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 result-table-count text-center"
  }, [_vm._v("\n              Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a\n              " + _vm._s(_vm.page.lastIndexShown()) + " de um total de\n              " + _vm._s(_vm.page.itemCount()) + "\n              encontrados.\n            ")])]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "myDiv"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    staticClass: "btn btn-back margin-t20",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v(" Voltar\n          ")])], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('i', {
    staticClass: "icon-info",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "A data de processamento que será considerada na filtragem."
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('h4', {
    staticClass: "title-box"
  }, [_vm._v("Resumo do Período")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "resume-transaction-col"
  }, [_vm._v("Tipo de transação")]), _vm._v(" "), _c('th', {
    staticClass: "resume-amount-col"
  }), _vm._v(" "), _c('th', {
    staticClass: "resume-value-col"
  }, [_vm._v("Valor em R$")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline value-box"
  }, [_c('p', {
    staticClass: "inline bold text-right",
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v("\n                Valor\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "inline bold text-right",
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_vm._v("\n                Saldo\n                "), _c('i', {
    staticClass: "icon-info",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Saldo após transação"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time-box inline"
  }, [_c('i', {
    staticClass: "icon-clock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statement-header-info-inside"
  }, [_c('p', {
    staticClass: "inline text-right bold"
  }, [_vm._v("Valor")]), _vm._v(" "), _c('p', {
    staticClass: "inline text-right bold"
  }, [_vm._v("Saldo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statement-header-info-inside"
  }, [_c('p', {
    staticClass: "inline text-right bold"
  }, [_vm._v("Valor")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-54278734!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/statement.vue
// module id = 2130
// module chunks = 1